import API from "../apis/api";
import { GetInfoResponse, ToTranslateField } from "../apis/response/GetInfoResponse";
import { GetTranslated, TranslateField } from "../types/translate-field";
import { createStyles, Stack, useMantineTheme, Text } from "@mantine/core";
import DefaultContainer from "../components/container";
import ImageStorageService from "../services/ImageStorageService";
import { SharedProps } from "../types/shared-props";
import { CurrentLocale } from "../App";
import { useEffect, useState } from "react";
import { GetNavbarCategoriesReponse, TransformToCategoryMenu } from "../apis/response/GetNavbarCategoriesResponse";
import { GetPortalResponse, ToPortalLink } from "../apis/response/GetPortalResponse";
import { useTranslation } from "react-i18next";

const useStyles = createStyles((theme) => ({
  contenthls: {
    Color: 'rgba(217,224,242, 1)',
  },
  abouthlsbg: {
    backgroundSize: "cover",
    backgroundPosition: "center",
    width: "100%",
    minHeight: 450,
    maxHeight: 450,
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
  },
  leftupabout: {
    width: '55%',
    height: '120%',
    backgroundColor: "rgba(217,224,242, 0.8)",
    padding: 0,
    marginLeft: 0,
    marginRight: -20,
    marginTop: '-5%',
    marginBottom: '-1%',
    paddingBottom: '1%',
    color: "rgba(8,72,171, 1)",
  },
  leftabout: {
    width: '55%',
    minHeight: 490,
    maxHeight: 490,
    backgroundColor: "rgba(217,224,242, 0.8)",
    padding: 0,
    marginLeft: 0,
    marginRight: -20,
    marginTop: '-1%',
    marginBottom: '-5%',
    paddingBottom: '14%',
    color: "rgba(8,72,171, 1)",
    zIndex: -1,
  },
  rightabout: {
    width: '55%',
    minHeight: 490,
    maxHeight: 490,
    backgroundColor: `${theme.colors.hkc[0]}EE`,
    padding: 0,
    marginLeft: -20,
    marginRight: 0,
    marginTop: '0%',
    marginBottom: '-5%',
    paddingBottom: '7%',
    zIndex: 5,
    color: "rgba(217,224,242, 1)",

  },
  abouthkcbg: {
    backgroundSize: "cover",
    backgroundPosition: "center",
    width: "100%",
    height: 900,
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
  },
  slash: {
    height: 10,
    backgroundColor: theme.colors.hkc[1],
    width: '100%',
    marginTop: 0,
    floats: 'center'
  },
  overlayText: {
    fontWeight: 900,
    fontSize: 25,
    color: "rgba(8,72,171, 1)",
    paddingBottom: 15,
    borderBottom: `5px solid ${theme.colors.hkc[1]}`,
    float: 'right',
    // width: '50%',
    width: 'min(83%, 600px)',
    margin: '0 0 0 auto',
    paddingTop: 30,
    height: 20,
    flexGrow: 1,
    display: 'flex',
    justifyContent: 'left',
    alignItems: 'center'
  },

  textContainer: {
    display: 'flex',
    [theme.fn.largerThan('md')]: {
      flexDirection: 'row'
    },
    [theme.fn.smallerThan('md')]: {
      flexDirection: 'column'
    },
  },
  leftDiv: {
    zIndex: 5,
    padding: '15px 0px 15px 100px',
    [theme.fn.largerThan('md')]: {
      width: '55%',
      marginTop: -65
    },
    [theme.fn.smallerThan('md')]: {
      width: '100%',
      marginTop: 0,
      padding: '15px 0px 15px 50px',
    },
    backgroundColor: "rgba(217,224,242, 0.9)",
  },
  rightDiv: {
    zIndex: 4,
    padding: '15px 0px 15px 100px',
    [theme.fn.largerThan('md')]: {
      width: '55%',
      marginBottom: -65,
      marginLeft: '-5%'
    },
    [theme.fn.smallerThan('md')]: {
      width: '100%',
      marginBottom: 0,
      marginLeft: 0,
      padding: '15px 0px 15px 50px',
    },
    backgroundColor: `${theme.colors.hkc[0]}EE`,
  },
  title: {
    display: 'flex',
    justifyContent: 'start',
    alignItems: 'end',
    paddingBottom: 10,
    width: '100%',
    borderBottom: `5px solid ${theme.colors.hkc[1]}`,
    fontWeight: 900,
    fontSize: 25,
    height: 50,
    fontFamily: theme.other.titleFont,
    [theme.fn.smallerThan('md')]: {
      fontSize:'17px'
    },
  },
  content: {
    marginBottom: 15,
    textAlign: 'left',
    marginRight:'100px',
    [theme.fn.smallerThan('md')]: {
      fontSize:'12px',
      marginRight:'50px'
    },
  },
  banner: {
  }
}));

interface AboutUsPageProps {
  hls?: TranslateField;
  hlss?: TranslateField;
  hkc?: TranslateField;
  hkcl?: TranslateField;
  hkcs?: TranslateField;
  img1Src?: string;
  img4Src?: string;
}


const ProductList = () => {
  const { classes } = useStyles();
  const init: AboutUsPageProps & SharedProps = {}
  const [props, setProps] = useState(init)
  const theme = useMantineTheme()
  const [bannerHeight, setBannerHeight] = useState(500)
  const [bottomBannerHeight, setBottomBannerHeight] = useState(600)
  


  const fetchData = async () => {
    const abouthkc: GetInfoResponse = (await API.Info.GetInfo("about_us_hkc1")).obj[0];
    const hkc = ToTranslateField(abouthkc);
    const abouthkcsec: GetInfoResponse = (await API.Info.GetInfo("about_us_hkc2"))
      .obj[0];
    const hkcs = ToTranslateField(abouthkcsec);
    const abouthls: GetInfoResponse = (await API.Info.GetInfo("about_us_hls1")).obj[0];
    const hls = ToTranslateField(abouthls);
    const abouthlssec: GetInfoResponse = (await API.Info.GetInfo("about_us_hls2"))
      .obj[0];
    const hlss = ToTranslateField(abouthlssec);

    const imgService = new ImageStorageService()
    const img1 = (await API.ImageStorage.Get("HKC Office2")).obj;

    const img1Src = imgService.FormatImageSrc(img1.items);
    const img2 = (await API.ImageStorage.Get("Mardel")).obj;
    const img2Src = imgService.FormatImageSrc(img2.items);
    const img3 = (await API.ImageStorage.Get("ConferenceRoom")).obj;
    const img3Src = imgService.FormatImageSrc(img3.items);

    const img4 = (await API.ImageStorage.Get("HOBBY LOBBY STORE")).obj;
    const img4Src = imgService.FormatImageSrc(img4.items);

    const c: GetNavbarCategoriesReponse = (await API.Category.GetNavbarCategories()).obj
    const categories = TransformToCategoryMenu(c.items)
    const usefulRes: GetPortalResponse = (await API.Info.GetUsefulLinks()).obj
    const useful = usefulRes.items.map(x => ToPortalLink(x))

    const newProps = {
      hkc, hkcs, hls, hlss, img1Src, img2Src, img3Src, img4Src, categories, useful
    }
    setProps(newProps)
  }

  const aboutus = useTranslation('aboutus');
  let h=500
  useEffect(() => {
    fetchData()

    
    handleWindowResize()
    window.addEventListener('resize', handleWindowResize);

    return () => {
      window.removeEventListener('resize', handleWindowResize);
    };
  }, [])

  function getWindowSize() {
    const {innerWidth, innerHeight} = window;
    return {innerWidth, innerHeight};
  }

  function handleWindowResize() {
    let w=getWindowSize().innerWidth*0.44;
    let w2=getWindowSize().innerWidth*0.72;
    setBannerHeight(w)
    setBottomBannerHeight(w2)
  }

  return (
      <DefaultContainer>
        <Stack spacing={0}>
          <div
            id="banner"
            style={{
              backgroundImage: `url(${props.img1Src})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              margin: 0,
              width: "100%",
              maxHeight: "500px",
              height: bannerHeight+'px',
            }} />

          <div className={classes.textContainer}>
            <div className={classes.leftDiv}>
              <Text className={classes.title}
                style={{ color: theme.colors.hkc[0] }}>{aboutus.t('hongkonglimited')}</Text>
              <div className={classes.content}
                style={{ marginTop: 15, color: `${theme.colors.hkc[0]}` }}
                dangerouslySetInnerHTML={{
                  __html: GetTranslated(props.hkc, CurrentLocale),
                }}
              />
              <div className={classes.content}
                style={{ color: `${theme.colors.hkc[0]}` }}
                dangerouslySetInnerHTML={{
                  __html: GetTranslated(props.hkcs, CurrentLocale),
                }}
              />
            </div>
            <div className={classes.rightDiv}>
              <Text className={classes.title}
                style={{ color: 'white', fontFamily: theme.other.englishFont.BerlinSans }}
              >Hobby Lobby Stores, Inc</Text>
              <div className={classes.content}
                style={{ marginTop: 15, color: 'white' }}
                dangerouslySetInnerHTML={{
                  __html: GetTranslated(props.hls, CurrentLocale),
                }}
              />
              <div className={classes.content}
                style={{ color: 'white' }}
                dangerouslySetInnerHTML={{
                  __html: GetTranslated(props.hlss, CurrentLocale),
                }}
              />
            </div>
          </div>
          <div
            style={{
              backgroundImage: `url(${props.img4Src})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              margin: 0,
              marginTop: 0,
              width: "100%",
              maxHeight: "600px",
              height: bottomBannerHeight+"px",
            }} />

        </Stack>

      </DefaultContainer>
  );
};

export default ProductList;
